<template>
  <div class="page" ref="pageEl">
    <!-- Croix arménienne (khatchkar) : réutilisée via <use> -->
    <svg width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false">
      <symbol id="hk-cross" viewBox="-34 -40 453 752">
<mask id="hkm" maskUnits="userSpaceOnUse" x="-20" y="-20" width="425" height="710"><rect x="-20" y="-20" width="425" height="710" fill="#fff"/><path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="#000" stroke-width="5" stroke-linejoin="round"/></mask>
<path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="currentColor" stroke-width="17" stroke-linejoin="round" mask="url(#hkm)"/>
<g transform="translate(98 40) rotate(-45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(287 40) rotate(45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 166) rotate(70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 344) rotate(110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(291 645) rotate(135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(97 645) rotate(-135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 344) rotate(-110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 166) rotate(-70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<circle cx="140" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="140" cy="44" r="5.7" fill="currentColor"/>
<circle cx="245" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="245" cy="44" r="5.7" fill="currentColor"/>
<circle cx="112" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="112" cy="88" r="5.7" fill="currentColor"/>
<circle cx="272" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="272" cy="88" r="5.7" fill="currentColor"/>
<circle cx="48" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="48" cy="208" r="5.7" fill="currentColor"/>
<circle cx="48" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="48" cy="302" r="5.7" fill="currentColor"/>
<circle cx="338" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="338" cy="208" r="5.7" fill="currentColor"/>
<circle cx="338" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="338" cy="302" r="5.7" fill="currentColor"/>
<circle cx="140" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="140" cy="602" r="5.7" fill="currentColor"/>
<circle cx="245" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="245" cy="602" r="5.7" fill="currentColor"/>
<circle cx="110" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="110" cy="592" r="5.7" fill="currentColor"/>
<circle cx="275" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="275" cy="592" r="5.7" fill="currentColor"/>
<circle cx="192" cy="245" r="74" fill="none" stroke="currentColor" stroke-width="5"/>
<line x1="252.0" y1="245.0" x2="265.0" y2="245.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="251.1" y1="255.4" x2="263.9" y2="257.7" stroke="currentColor" stroke-width="2.5"/>
<line x1="248.4" y1="265.5" x2="260.6" y2="270.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="244.0" y1="275.0" x2="255.2" y2="281.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="238.0" y1="283.6" x2="247.9" y2="291.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="230.6" y1="291.0" x2="238.9" y2="300.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="222.0" y1="297.0" x2="228.5" y2="308.2" stroke="currentColor" stroke-width="2.5"/>
<line x1="212.5" y1="301.4" x2="217.0" y2="313.6" stroke="currentColor" stroke-width="2.5"/>
<line x1="202.4" y1="304.1" x2="204.7" y2="316.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="192.0" y1="305.0" x2="192.0" y2="318.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="181.6" y1="304.1" x2="179.3" y2="316.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="171.5" y1="301.4" x2="167.0" y2="313.6" stroke="currentColor" stroke-width="2.5"/>
<line x1="162.0" y1="297.0" x2="155.5" y2="308.2" stroke="currentColor" stroke-width="2.5"/>
<line x1="153.4" y1="291.0" x2="145.1" y2="300.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="146.0" y1="283.6" x2="136.1" y2="291.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="140.0" y1="275.0" x2="128.8" y2="281.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="135.6" y1="265.5" x2="123.4" y2="270.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="132.9" y1="255.4" x2="120.1" y2="257.7" stroke="currentColor" stroke-width="2.5"/>
<line x1="132.0" y1="245.0" x2="119.0" y2="245.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="132.9" y1="234.6" x2="120.1" y2="232.3" stroke="currentColor" stroke-width="2.5"/>
<line x1="135.6" y1="224.5" x2="123.4" y2="220.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="140.0" y1="215.0" x2="128.8" y2="208.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="146.0" y1="206.4" x2="136.1" y2="198.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="153.4" y1="199.0" x2="145.1" y2="189.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="162.0" y1="193.0" x2="155.5" y2="181.8" stroke="currentColor" stroke-width="2.5"/>
<line x1="171.5" y1="188.6" x2="167.0" y2="176.4" stroke="currentColor" stroke-width="2.5"/>
<line x1="181.6" y1="185.9" x2="179.3" y2="173.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="192.0" y1="185.0" x2="192.0" y2="172.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="202.4" y1="185.9" x2="204.7" y2="173.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="212.5" y1="188.6" x2="217.0" y2="176.4" stroke="currentColor" stroke-width="2.5"/>
<line x1="222.0" y1="193.0" x2="228.5" y2="181.8" stroke="currentColor" stroke-width="2.5"/>
<line x1="230.6" y1="199.0" x2="238.9" y2="189.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="238.0" y1="206.4" x2="247.9" y2="198.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="244.0" y1="215.0" x2="255.2" y2="208.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="248.4" y1="224.5" x2="260.6" y2="220.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="251.1" y1="234.6" x2="263.9" y2="232.3" stroke="currentColor" stroke-width="2.5"/>
<circle cx="192" cy="245" r="52" fill="none" stroke="currentColor" stroke-width="6"/>
<path d="M202.0 245.0 L205.5 246.7 L208.7 249.3 L211.4 252.6 L213.4 256.7 L214.7 261.4 L215.1 266.5 L214.6 272.0 L213.0 277.6 L210.3 283.3 L206.5 288.7" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M199.1 252.1 L200.3 255.7 L200.8 259.8 L200.3 264.1 L198.9 268.4 L196.5 272.6 L193.1 276.6 L188.9 280.1 L183.7 282.9 L177.9 285.0 L171.4 286.1" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M192.0 255.0 L190.3 258.5 L187.7 261.7 L184.4 264.4 L180.3 266.4 L175.6 267.7 L170.5 268.1 L165.0 267.6 L159.4 266.0 L153.7 263.3 L148.3 259.5" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M184.9 252.1 L181.3 253.3 L177.2 253.8 L172.9 253.3 L168.6 251.9 L164.4 249.5 L160.4 246.1 L156.9 241.9 L154.1 236.7 L152.0 230.9 L150.9 224.4" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M182.0 245.0 L178.5 243.3 L175.3 240.7 L172.6 237.4 L170.6 233.3 L169.3 228.6 L168.9 223.5 L169.4 218.0 L171.0 212.4 L173.7 206.7 L177.5 201.3" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M184.9 237.9 L183.7 234.3 L183.2 230.2 L183.7 225.9 L185.1 221.6 L187.5 217.4 L190.9 213.4 L195.1 209.9 L200.3 207.1 L206.1 205.0 L212.6 203.9" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M192.0 235.0 L193.7 231.5 L196.3 228.3 L199.6 225.6 L203.7 223.6 L208.4 222.3 L213.5 221.9 L219.0 222.4 L224.6 224.0 L230.3 226.7 L235.7 230.5" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M199.1 237.9 L202.7 236.7 L206.8 236.2 L211.1 236.7 L215.4 238.1 L219.6 240.5 L223.6 243.9 L227.1 248.1 L229.9 253.3 L232.0 259.1 L233.1 265.6" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="192" cy="245" r="8" fill="currentColor"/>
<path d="M192.0 330.0 L195.0 333.0 L197.9 336.0 L200.6 339.0 L203.0 342.0 L205.1 345.0 L206.8 348.0 L208.1 351.0 L208.8 354.0 L209.0 357.0 L208.7 360.0 L207.8 363.0 L206.5 366.0 L204.7 369.0 L202.6 372.0 L200.1 375.0 L197.3 378.0 L194.4 381.0 L191.4 384.0 L188.4 387.0 L185.6 390.0 L182.9 393.0 L180.5 396.0 L178.5 399.0 L176.9 402.0 L175.8 405.0 L175.1 408.0 L175.0 411.0 L175.4 414.0 L176.4 417.0 L177.8 420.0 L179.7 423.0 L181.9 426.0 L184.5 429.0 L187.2 432.0 L190.2 435.0 L193.2 438.0 L196.1 441.0 L199.0 444.0 L201.6 447.0 L203.9 450.0 L205.8 453.0 L207.4 456.0 L208.4 459.0 L208.9 462.0 L208.9 465.0 L208.4 468.0 L207.4 471.0 L205.9 474.0 L203.9 477.0 L201.6 480.0 L199.0 483.0 L196.2 486.0 L193.2 489.0 L190.2 492.0 L187.3 495.0 L184.5 498.0 L181.9 501.0 L179.7 504.0 L177.8 507.0 L176.4 510.0 L175.5 513.0 L175.0 516.0 L175.1 519.0 L175.8 522.0 L176.9 525.0 L178.5 528.0 L180.5 531.0 L182.9 534.0 L185.5 537.0 L188.4 540.0 L191.4 543.0" fill="none" stroke="currentColor" stroke-width="7" stroke-linecap="round"/>
<path d="M192.0 330.0 L189.0 333.0 L186.1 336.0 L183.4 339.0 L181.0 342.0 L178.9 345.0 L177.2 348.0 L175.9 351.0 L175.2 354.0 L175.0 357.0 L175.3 360.0 L176.2 363.0 L177.5 366.0 L179.3 369.0 L181.4 372.0 L183.9 375.0 L186.7 378.0 L189.6 381.0 L192.6 384.0 L195.6 387.0 L198.4 390.0 L201.1 393.0 L203.5 396.0 L205.5 399.0 L207.1 402.0 L208.2 405.0 L208.9 408.0 L209.0 411.0 L208.6 414.0 L207.6 417.0 L206.2 420.0 L204.3 423.0 L202.1 426.0 L199.5 429.0 L196.8 432.0 L193.8 435.0 L190.8 438.0 L187.9 441.0 L185.0 444.0 L182.4 447.0 L180.1 450.0 L178.2 453.0 L176.6 456.0 L175.6 459.0 L175.1 462.0 L175.1 465.0 L175.6 468.0 L176.6 471.0 L178.1 474.0 L180.1 477.0 L182.4 480.0 L185.0 483.0 L187.8 486.0 L190.8 489.0 L193.8 492.0 L196.7 495.0 L199.5 498.0 L202.1 501.0 L204.3 504.0 L206.2 507.0 L207.6 510.0 L208.5 513.0 L209.0 516.0 L208.9 519.0 L208.2 522.0 L207.1 525.0 L205.5 528.0 L203.5 531.0 L201.1 534.0 L198.5 537.0 L195.6 540.0 L192.6 543.0" fill="none" stroke="currentColor" stroke-width="7" stroke-linecap="round"/>
<circle cx="192" cy="330.0" r="3.5" fill="currentColor"/>
<circle cx="192" cy="356.7" r="3.5" fill="currentColor"/>
<circle cx="192" cy="383.4" r="3.5" fill="currentColor"/>
<circle cx="192" cy="410.1" r="3.5" fill="currentColor"/>
<circle cx="192" cy="436.8" r="3.5" fill="currentColor"/>
<circle cx="192" cy="463.5" r="3.5" fill="currentColor"/>
<circle cx="192" cy="490.2" r="3.5" fill="currentColor"/>
<g transform="translate(192 170) rotate(0)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="4" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<g transform="translate(192 555) rotate(180)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="4" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<path d="M192 560 L165 590 L192 600 L219 590Z" fill="none" stroke="currentColor" stroke-width="4" stroke-linejoin="round"/>
      </symbol>
      <symbol id="hk-cross-sm" viewBox="-44 -40 473 752">
<mask id="hkm-sm" maskUnits="userSpaceOnUse" x="-20" y="-20" width="425" height="710"><rect x="-20" y="-20" width="425" height="710" fill="#fff"/><path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="#000" stroke-width="6" stroke-linejoin="round"/></mask>
<path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="currentColor" stroke-width="19" stroke-linejoin="round" mask="url(#hkm-sm)"/>
<g transform="translate(98 40) rotate(-45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(287 40) rotate(45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 166) rotate(70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 344) rotate(110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(291 645) rotate(135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(97 645) rotate(-135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 344) rotate(-110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 166) rotate(-70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<circle cx="140" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="140" cy="44" r="7" fill="currentColor"/>
<circle cx="245" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="245" cy="44" r="7" fill="currentColor"/>
<circle cx="112" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="112" cy="88" r="7" fill="currentColor"/>
<circle cx="272" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="272" cy="88" r="7" fill="currentColor"/>
<circle cx="48" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="48" cy="208" r="7" fill="currentColor"/>
<circle cx="48" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="48" cy="302" r="7" fill="currentColor"/>
<circle cx="338" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="338" cy="208" r="7" fill="currentColor"/>
<circle cx="338" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="338" cy="302" r="7" fill="currentColor"/>
<circle cx="140" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="140" cy="602" r="7" fill="currentColor"/>
<circle cx="245" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="245" cy="602" r="7" fill="currentColor"/>
<circle cx="110" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="110" cy="592" r="7" fill="currentColor"/>
<circle cx="275" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="275" cy="592" r="7" fill="currentColor"/>
<circle cx="192" cy="245" r="76" fill="none" stroke="currentColor" stroke-width="8"/>
<line x1="254.0" y1="245.0" x2="266.0" y2="245.0" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="250.3" y1="266.2" x2="261.5" y2="270.3" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="239.5" y1="284.9" x2="248.7" y2="292.6" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="223.0" y1="298.7" x2="229.0" y2="309.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="202.8" y1="306.1" x2="204.8" y2="317.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="181.2" y1="306.1" x2="179.2" y2="317.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="161.0" y1="298.7" x2="155.0" y2="309.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="144.5" y1="284.9" x2="135.3" y2="292.6" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="133.7" y1="266.2" x2="122.5" y2="270.3" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="130.0" y1="245.0" x2="118.0" y2="245.0" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="133.7" y1="223.8" x2="122.5" y2="219.7" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="144.5" y1="205.1" x2="135.3" y2="197.4" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="161.0" y1="191.3" x2="155.0" y2="180.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="181.2" y1="183.9" x2="179.2" y2="172.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="202.8" y1="183.9" x2="204.8" y2="172.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="223.0" y1="191.3" x2="229.0" y2="180.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="239.5" y1="205.1" x2="248.7" y2="197.4" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="250.3" y1="223.8" x2="261.5" y2="219.7" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<circle cx="192" cy="245" r="54" fill="none" stroke="currentColor" stroke-width="9"/>
<path d="M207.0 245.0 L209.9 247.4 L212.4 250.7 L214.3 254.6 L215.5 259.1 L215.8 264.1 L215.2 269.3 L213.5 274.7 L210.8 280.1 L206.9 285.2 L202.1 289.9" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M201.4 256.7 L201.3 260.5 L200.3 264.5 L198.4 268.4 L195.6 272.2 L191.9 275.5 L187.4 278.3 L182.1 280.4 L176.3 281.6 L169.9 281.8 L163.2 280.9" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M188.7 259.6 L185.6 261.9 L181.9 263.7 L177.7 264.6 L173.0 264.8 L168.1 264.0 L163.1 262.2 L158.2 259.3 L153.6 255.5 L149.5 250.6 L146.0 244.8" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M178.5 251.5 L174.8 250.6 L171.1 248.8 L167.7 246.1 L164.7 242.5 L162.3 238.2 L160.6 233.1 L159.7 227.5 L159.9 221.5 L161.1 215.3 L163.4 208.9" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M178.5 238.5 L176.9 235.0 L176.0 231.0 L176.0 226.7 L176.9 222.1 L178.8 217.5 L181.7 213.0 L185.5 208.9 L190.3 205.2 L196.0 202.3 L202.4 200.2" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M188.7 230.4 L190.4 227.0 L193.0 223.8 L196.4 221.1 L200.5 219.0 L205.3 217.5 L210.6 217.0 L216.2 217.4 L222.0 218.9 L227.9 221.5 L233.5 225.2" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M201.4 233.3 L205.1 232.5 L209.2 232.6 L213.4 233.5 L217.7 235.4 L221.7 238.3 L225.5 242.1 L228.7 246.7 L231.1 252.2 L232.8 258.4 L233.4 265.1" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="192" cy="245" r="9" fill="currentColor"/>
<path d="M192.0 330.0 L195.0 333.0 L197.9 336.0 L200.6 339.0 L203.0 342.0 L205.1 345.0 L206.8 348.0 L208.1 351.0 L208.8 354.0 L209.0 357.0 L208.7 360.0 L207.8 363.0 L206.5 366.0 L204.7 369.0 L202.6 372.0 L200.1 375.0 L197.3 378.0 L194.4 381.0 L191.4 384.0 L188.4 387.0 L185.6 390.0 L182.9 393.0 L180.5 396.0 L178.5 399.0 L176.9 402.0 L175.8 405.0 L175.1 408.0 L175.0 411.0 L175.4 414.0 L176.4 417.0 L177.8 420.0 L179.7 423.0 L181.9 426.0 L184.5 429.0 L187.2 432.0 L190.2 435.0 L193.2 438.0 L196.1 441.0 L199.0 444.0 L201.6 447.0 L203.9 450.0 L205.8 453.0 L207.4 456.0 L208.4 459.0 L208.9 462.0 L208.9 465.0 L208.4 468.0 L207.4 471.0 L205.9 474.0 L203.9 477.0 L201.6 480.0 L199.0 483.0 L196.2 486.0 L193.2 489.0 L190.2 492.0 L187.3 495.0 L184.5 498.0 L181.9 501.0 L179.7 504.0 L177.8 507.0 L176.4 510.0 L175.5 513.0 L175.0 516.0 L175.1 519.0 L175.8 522.0 L176.9 525.0 L178.5 528.0 L180.5 531.0 L182.9 534.0 L185.5 537.0 L188.4 540.0 L191.4 543.0" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
<path d="M192.0 330.0 L189.0 333.0 L186.1 336.0 L183.4 339.0 L181.0 342.0 L178.9 345.0 L177.2 348.0 L175.9 351.0 L175.2 354.0 L175.0 357.0 L175.3 360.0 L176.2 363.0 L177.5 366.0 L179.3 369.0 L181.4 372.0 L183.9 375.0 L186.7 378.0 L189.6 381.0 L192.6 384.0 L195.6 387.0 L198.4 390.0 L201.1 393.0 L203.5 396.0 L205.5 399.0 L207.1 402.0 L208.2 405.0 L208.9 408.0 L209.0 411.0 L208.6 414.0 L207.6 417.0 L206.2 420.0 L204.3 423.0 L202.1 426.0 L199.5 429.0 L196.8 432.0 L193.8 435.0 L190.8 438.0 L187.9 441.0 L185.0 444.0 L182.4 447.0 L180.1 450.0 L178.2 453.0 L176.6 456.0 L175.6 459.0 L175.1 462.0 L175.1 465.0 L175.6 468.0 L176.6 471.0 L178.1 474.0 L180.1 477.0 L182.4 480.0 L185.0 483.0 L187.8 486.0 L190.8 489.0 L193.8 492.0 L196.7 495.0 L199.5 498.0 L202.1 501.0 L204.3 504.0 L206.2 507.0 L207.6 510.0 L208.5 513.0 L209.0 516.0 L208.9 519.0 L208.2 522.0 L207.1 525.0 L205.5 528.0 L203.5 531.0 L201.1 534.0 L198.5 537.0 L195.6 540.0 L192.6 543.0" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
<circle cx="192" cy="330.0" r="5" fill="currentColor"/>
<circle cx="192" cy="356.7" r="5" fill="currentColor"/>
<circle cx="192" cy="383.4" r="5" fill="currentColor"/>
<circle cx="192" cy="410.1" r="5" fill="currentColor"/>
<circle cx="192" cy="436.8" r="5" fill="currentColor"/>
<circle cx="192" cy="463.5" r="5" fill="currentColor"/>
<circle cx="192" cy="490.2" r="5" fill="currentColor"/>
<g transform="translate(192 170) rotate(0)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="6" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<g transform="translate(192 555) rotate(180)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="6" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<path d="M192 560 L165 590 L192 600 L219 590Z" fill="none" stroke="currentColor" stroke-width="6" stroke-linejoin="round"/>
      </symbol>
    </svg>

    <div class="progress" :style="{ transform: `scaleX(${progress})` }" aria-hidden="true"></div>

    <!-- ============ BARRE DU HAUT ============ -->
    <header class="topbar" :class="{ scrolled }">
      <router-link to="/" class="wordmark" aria-label="HayMiutyun – accueil">
        <span class="wordmark-letter" aria-hidden="true"><img :src="Logo" alt="" /></span>
        <span class="wordmark-text">Hay<b>Miutyun</b></span>
      </router-link>

      <nav class="topnav" aria-label="Sections">
        <a href="#mission" @click.prevent="goTo('mission')">Mission</a>
        <a href="#evenements" @click.prevent="goTo('evenements')">Événements</a>
        <a href="#soutien" @click.prevent="goTo('soutien')">Soutien</a>
        <a href="#partenaires" @click.prevent="goTo('partenaires')">Partenaires</a>
      </nav>

      <div class="account">
        <template v-if="!user">
          <router-link to="/login" class="link-quiet">Se connecter</router-link>
          <router-link to="/register" class="pill-btn">Créer un compte</router-link>
        </template>

        <div v-else class="user-menu" ref="menuEl">
          <button
            type="button"
            class="user-btn"
            :aria-expanded="menuOpen"
            aria-haspopup="true"
            @click="menuOpen = !menuOpen"
          >
            <span class="avatar">{{ initial }}</span>
            <span class="user-label">Mon espace</span>
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>
          </button>

          <transition name="pop">
            <ul v-if="menuOpen" class="menu" role="menu">
              <li role="none"><router-link role="menuitem" to="/account" @click="menuOpen = false">Mon compte</router-link></li>
              <li role="none"><router-link role="menuitem" to="/my-requests" @click="menuOpen = false">Mes publications</router-link></li>
              <li v-if="user.role === 'Admin'" role="none">
                <router-link role="menuitem" to="/dashboard" class="menu-admin" @click="menuOpen = false">
                  Administration <small>Espace de gestion</small>
                </router-link>
              </li>
              <li role="none"><button role="menuitem" type="button" @click="logout">Déconnexion</button></li>
            </ul>
          </transition>
        </div>
      </div>
    </header>

    <!-- ============ HERO ============ -->
    <section class="hero" ref="heroEl" @mousemove="onHeroMove" @mouseleave="resetParallax">
      <div class="hero-bg" aria-hidden="true">
        <div class="lattice"></div>
        <svg class="bg-cross bg-cross--a"><use href="#hk-cross" /></svg>
        <svg class="bg-cross bg-cross--b"><use href="#hk-cross" /></svg>
        <span class="bg-stripe"></span>
      </div>

      <div class="hero-grid">
        <div class="hero-copy">
          <p class="eyebrow">
            <svg class="eyebrow-cross" aria-hidden="true"><use href="#hk-cross-sm" /></svg>
            Հայ Միություն · Solidarité arménienne
          </p>

          <h1>
            Ensemble, nous construisons
            <span class="h1-accent">une communauté<br />plus forte<i class="underline"></i></span>
          </h1>

          <p class="lead">
            HayMiutyun rassemble les personnes qui souhaitent aider, partager et
            soutenir les membres de notre communauté.
          </p>

          <div class="hero-actions">
            <button class="btn btn-primary" @click="openHelpForm">
              <span>Demander de l'aide</span>
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6"/></svg>
            </button>
            <button class="btn btn-ghost" @click="router.push('/publish')">Voir les demandes</button>
          </div>

          <dl class="stats">
            <div v-for="s in stats" :key="s.label" class="stat">
              <dt>
                <span class="stat-plus">+</span><span>{{ Math.round(s.shown) }}</span>
              </dt>
              <dd>{{ s.label }}</dd>
            </div>
          </dl>
        </div>

        <!-- Emblème animé -->
        <div class="hero-art" aria-hidden="true">
          <div class="emblem" :style="emblemStyle">
            <svg class="ring ring--text" viewBox="0 0 400 400">
              <defs>
                <path id="circle-path" d="M200,200 m-165,0 a165,165 0 1,1 330,0 a165,165 0 1,1 -330,0" />
              </defs>
              <text>
                <textPath href="#circle-path" startOffset="0">
                  ՀԱՅ ՄԻՈՒԹՅՈՒՆ · ՄԻԱՍԻՆ · ՀԱՄԱՅՆՔ · ՕԳՆՈՒԹՅՈՒՆ · ՀԱՄԵՐԱՇԽՈՒԹՅՈՒՆ ·
                </textPath>
              </text>
            </svg>

            <svg class="ring ring--geo" viewBox="0 0 400 400" fill="none" stroke-width="2">
              <rect x="95" y="95" width="210" height="210" rx="18" stroke="#d90012" />
              <rect x="95" y="95" width="210" height="210" rx="18" stroke="#0033a0" transform="rotate(45 200 200)" />
              <rect x="95" y="95" width="210" height="210" rx="18" stroke="#f2a800" transform="rotate(22.5 200 200)" opacity=".9" />
              <rect x="95" y="95" width="210" height="210" rx="18" stroke="#d90012" transform="rotate(67.5 200 200)" opacity=".35" />
            </svg>

            <div class="core">
              <img class="core-logo" :src="Logo" alt="" />
            </div>
          </div>

          <span class="chip chip--a" :style="chipStyle(14)"><i class="dot red"></i> Entraide</span>
          <span class="chip chip--b" :style="chipStyle(-20)"><i class="dot blue"></i> Solidarité</span>
          <span class="chip chip--c" :style="chipStyle(10)"><i class="dot orange"></i> Communauté</span>
        </div>
      </div>

      <a class="scroll-cue" href="#mission" @click.prevent="goTo('mission')" aria-label="Découvrir la suite">
        <span></span>
      </a>
    </section>

    <!-- ============ BANDEAU DÉFILANT ============ -->
    <section class="marquee" aria-hidden="true">
      <div class="marquee-track">
        <template v-for="n in 2" :key="n">
          <span v-for="w in marqueeWords" :key="w + n" class="marquee-item">{{ w }}<i></i></span>
        </template>
      </div>
    </section>

    <!-- ============ CITATION ============ -->
    <section class="quote-section" ref="quoteEl">
      <svg class="quote-mark" viewBox="0 0 48 48" aria-hidden="true"><path d="M10 28c0-8 4-14 12-16l1 3c-4 1.4-6 4-6.4 7H22v12H10V28zm18 0c0-8 4-14 12-16l1 3c-4 1.4-6 4-6.4 7H40v12H28V28z"/></svg>
      <blockquote class="quote">
        <span class="quote-ghost" aria-hidden="true">{{ fullQuote }}</span>
        <span class="quote-typed" :aria-label="fullQuote">{{ animatedQuote }}<i class="caret"></i></span>
      </blockquote>
      <p class="quote-author">— William Saroyan</p>
    </section>

    <!-- ============ MISSION ============ -->
    <section id="mission" class="mission">
      <div class="mission-intro reveal">
        <span class="kicker">
            <svg class="kicker-cross" aria-hidden="true"><use href="#hk-cross-sm" /></svg>
            Notre mission
          </span>
        <h2>Qu’est-ce que <em>HayMiutyun</em>&nbsp;?</h2>
        <p>
          Une plateforme créée pour rapprocher les personnes qui ont besoin
          d’aide et celles qui souhaitent agir.
        </p>
      </div>

      <div class="values">
        <article v-for="(v, i) in values" :key="v.title" class="value reveal" :style="{ '--d': i * 0.12 + 's' }">
          <span class="value-num">0{{ i + 1 }}</span>
          <div class="value-icon" v-html="v.icon"></div>
          <h3>{{ v.title }}</h3>
          <p>{{ v.text }}</p>
          <span class="value-line"></span>
        </article>
      </div>
    </section>

    <!-- ============ ÉVÉNEMENTS ============ -->
    <section id="evenements" class="events">
      <div class="events-head reveal">
        <div>
          <span class="kicker">
            <svg class="kicker-cross" aria-hidden="true"><use href="#hk-cross-sm" /></svg>
            Agenda communautaire
          </span>
          <h2>Événements arméniens</h2>
          <p>Retrouvez les prochains événements de la communauté arménienne.</p>
        </div>
        <div class="events-actions">
          <button class="btn btn-primary btn-sm" @click="openEventForm">+ Créer un événement</button>
          <button class="btn btn-outline btn-sm" @click="router.push('/events')">Voir les événements →</button>
        </div>
      </div>

      <div v-if="loadingEvents" class="events-grid" aria-busy="true">
        <div v-for="n in 3" :key="n" class="event-card skeleton"></div>
      </div>

      <div v-else-if="events.length" class="events-grid">
        <article
          v-for="(event, i) in events.slice(0, 3)"
          :key="event.id"
          class="event-card reveal"
          :style="{ '--d': i * 0.12 + 's' }"
        >
          <div class="event-image">
            <img v-if="event.image" :src="event.image" :alt="event.title" loading="lazy" />
            <div v-else class="event-placeholder" aria-hidden="true"><svg class="placeholder-cross"><use href="#hk-cross" /></svg></div>

            <div class="event-date">
              <strong>{{ formatDay(event.date) }}</strong>
              <span>{{ formatMonth(event.date) }}</span>
            </div>
          </div>

          <div class="event-content">
            <span class="event-location">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 21s-7-6-7-11a7 7 0 0 1 14 0c0 5-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>
              {{ event.location }}
            </span>
            <h3>{{ event.title }}</h3>

            <div class="event-footer">
              <span class="event-time">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
                {{ formatTime(event.time) }}
              </span>
              <button class="event-details-btn" @click="openEventDetails(event.publicId)">
                Voir les détails <span aria-hidden="true">→</span>
              </button>
            </div>
          </div>
        </article>
      </div>

      <div v-else class="events-empty reveal">
        <svg class="empty-cross" aria-hidden="true"><use href="#hk-cross-sm" /></svg>
        <h3>Aucun événement prochainement</h3>
        <p>Soyez le premier à proposer une rencontre pour la communauté.</p>
        <button class="btn btn-primary btn-sm" @click="openEventForm">Créer un événement</button>
      </div>
    </section>

    <!-- ============ DON ============ -->
    <section id="soutien" class="donation">
      <div class="donation-box reveal">
        <div class="donation-art" aria-hidden="true">
          <span class="ring r1"></span>
          <span class="ring r2"></span>
          <span class="ring r3"></span>
          <span class="donation-letter"><svg class="donation-cross"><use href="#hk-cross-sm" /></svg></span>
        </div>

        <div class="donation-content">
          <span class="donation-small">Soutenir notre mission</span>
          <h2>Aidez HayMiutyun à grandir</h2>
          <p>
            Votre soutien permet d'organiser des projets solidaires, des événements
            communautaires et d'aider davantage de personnes.
          </p>

          <div class="donation-actions">
            <button class="btn btn-light" @click="router.push('/support')">Faire un don</button>
            <span>Chaque contribution compte</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ PARTENAIRES ============ -->
    <section id="partenaires" class="partners">
      <div class="partners-head reveal">
        <span class="kicker">
            <svg class="kicker-cross" aria-hidden="true"><use href="#hk-cross-sm" /></svg>
            Ensemble
          </span>
        <h2>Nos associations partenaires</h2>
        <p>Des acteurs engagés qui partagent nos valeurs de solidarité et d’entraide.</p>
      </div>

      <div class="partner-list">
        <a
          v-for="(partner, index) in partners"
          :key="index"
          :href="partner.url"
          target="_blank"
          rel="noopener noreferrer"
          class="partner-card reveal"
          :style="{ '--d': index * 0.1 + 's' }"
          :aria-label="partner.name"
        >
          <img :src="partner.image" :alt="partner.name" loading="lazy" />
        </a>
      </div>
    </section>

    <!-- ============ FOOTER ============ -->
    <footer class="footer">
      <div class="footer-top">
        <div class="footer-brand">
          <span class="footer-wordmark">Hay<b>Miutyun</b></span>
          <p>Un réseau de confiance, de partage et de bienveillance pour la communauté arménienne.</p>

          <div class="social-grid">
            <a
              v-for="social in socials"
              :key="social.name"
              :href="social.url"
              target="_blank"
              rel="noopener noreferrer"
              class="social-link"
              :aria-label="social.name"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true" v-html="social.svg"></svg>
            </a>
          </div>
        </div>

        <div class="footer-column">
          <h3>Communauté</h3>
          <a href="/about">Qui sommes-nous ?</a>
          <a href="/faq">Questions fréquentes</a>
          <a href="/join">Nous rejoindre</a>
        </div>

        <div class="footer-column">
          <h3>Participer</h3>
          <a href="/partners">Nos partenaires</a>
          <a href="/support">Nous soutenir</a>
          <a href="/become">Devenir partenaire</a>
        </div>
      </div>

      <div class="footer-bottom">
        <p>© {{ new Date().getFullYear() }} HayMiutyun • Solidarité arménienne</p>
        <button type="button" class="to-top" @click="scrollTop" aria-label="Revenir en haut">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 14 6-6 6 6"/></svg>
        </button>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { computed, nextTick, onBeforeUnmount, onMounted, reactive, ref } from "vue"
import { useRouter } from "vue-router"

import Logo from "@/assets/HayMiutyunRemove.png"
import Association1 from "@/assets/association1.png"
import Association2 from "@/assets/plessis-robinson.jpg"
import Association3 from "@/assets/association3.png"

import API_URL from "@/config/api"

const router = useRouter()

/* =========================
   DONNÉES STATIQUES
========================= */

const socials = [
  {
    name: "Instagram",
    url: "https://www.instagram.com/hay.miutyun",
    svg: '<rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle class="fill" cx="17.5" cy="6.5" r="1"/>'
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/share/19NbswZnw1/",
    svg: '<path d="M14 8h2.5V4H14a3.5 3.5 0 0 0-3.5 3.5V10H8v4h2.5v7H14v-7h2.5l.5-4H14V8z"/>'
  },
  {
    name: "TikTok",
    url: "https://www.tiktok.com/@haymiutyun",
    svg: '<path d="M14 3v11.2a4.2 4.2 0 1 1-4-4.2"/><path d="M14 3c.5 3 2.5 5 5.5 5.3"/>'
  },
  {
    name: "YouTube",
    url: "https://www.youtube.com/@HayMiutyun",
    svg: '<rect x="2.5" y="5" width="19" height="14" rx="4"/><path class="fill" d="m10 9 5 3-5 3z"/>'
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/hay-miutyun",
    svg: '<path d="M5 9v10"/><path d="M5 5v.1"/><path d="M10 19v-6a4 4 0 0 1 8 0v6"/><path d="M10 10v9"/>'
  }
]

const partners = [
  { name: "Association 1", url: "https://association1.fr", image: Association1 },
  { name: "Association 2", url: "https://www.plessis-robinson.com", image: Association2 },
  { name: "Association 3", url: "https://association3.fr", image: Association3 }
]

const values = [
  {
    title: "Entraide",
    text: "Accompagner les membres de la communauté dans leurs besoins du quotidien.",
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M7 11V5.5a1.5 1.5 0 0 1 3 0V10"/><path d="M10 10V4.5a1.5 1.5 0 0 1 3 0V10"/><path d="M13 10V6a1.5 1.5 0 0 1 3 0v6"/><path d="M16 12V9a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1-6 6h-2.5a5 5 0 0 1-4.5-3l-1.5-3a1.8 1.8 0 0 1 3-2l2 2"/></svg>'
  },
  {
    title: "Solidarité",
    text: "Créer un réseau basé sur la confiance, le partage et la bienveillance.",
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 5.6-7 10-7 10z"/></svg>'
  },
  {
    title: "Communauté",
    text: "Rassembler les générations autour d’un objectif commun.",
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="7" r="3"/><path d="M5 21a7 7 0 0 1 14 0"/></svg>'
  }
]

const marqueeWords = [
  "Entraide", "Միասին", "Solidarité", "Համայնք", "Partage", "Օգնություն", "Communauté", "Համերաշխություն"
]

/* =========================
   STATS (compteurs animés)
========================= */

const stats = reactive([
  { label: "Membres", target: 740, shown: 0 },
  { label: "Aides proposées", target: 40, shown: 0 },
  { label: "Partenaires", target: 15, shown: 0 }
])

const reduceMotion =
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches

const animateStats = () => {
  if (reduceMotion) {
    stats.forEach((s) => (s.shown = s.target))
    return
  }
  const duration = 1600
  const start = performance.now()
  const tick = (now) => {
    const t = Math.min((now - start) / duration, 1)
    const eased = 1 - Math.pow(1 - t, 4)
    stats.forEach((s) => (s.shown = s.target * eased))
    if (t < 1) requestAnimationFrame(tick)
  }
  requestAnimationFrame(tick)
}

/* =========================
   ÉVÉNEMENTS
========================= */

const events = ref([])
const loadingEvents = ref(true)

const loadEvents = async () => {
  try {
    const response = await fetch(`${API_URL}/api/events/published`)
    if (!response.ok) throw new Error("Impossible de charger les événements")
    events.value = await response.json()
  } catch (error) {
    console.error("Erreur événements :", error)
    events.value = []
  } finally {
    loadingEvents.value = false
    await nextTick()
    observeReveals()
  }
}

const openEventDetails = (publicId) => {
  const stored = JSON.parse(localStorage.getItem("user"))
  if (!stored) {
    router.push("/login")
    return
  }
  router.push(`/events/${publicId}`)
}

const formatDay = (date) => new Date(date).getDate()

const formatMonth = (date) =>
  new Date(date)
    .toLocaleDateString("fr-FR", { month: "short" })
    .replace(".", "")
    .toUpperCase()

const formatTime = (time) => {
  if (!time) return "Heure non précisée"
  if (typeof time === "string") {
    const parts = time.split(":")
    if (parts.length >= 2) return `${parts[0]}:${parts[1]}`
  }
  return time
}

/* =========================
   UTILISATEUR
========================= */

const user = ref(null)
const menuOpen = ref(false)
const menuEl = ref(null)

const initial = computed(() => {
  const u = user.value || {}
  const base = u.firstName || u.name || u.userName || u.email || "M"
  return String(base).trim().charAt(0).toUpperCase()
})

const openHelpForm = () => {
  if (!user.value) return router.push("/login")
  router.push("/help")
}

const openEventForm = () => {
  if (!user.value) return router.push("/login")
  router.push("/createEvents")
}

const logout = () => {
  localStorage.removeItem("user")
  user.value = null
  menuOpen.value = false
  router.push("/")
}

const onDocClick = (e) => {
  if (menuOpen.value && menuEl.value && !menuEl.value.contains(e.target)) {
    menuOpen.value = false
  }
}

/* =========================
   NAVIGATION / SCROLL
========================= */

const scrolled = ref(false)
const progress = ref(0)

const onScroll = () => {
  const y = window.scrollY
  scrolled.value = y > 24
  const max = document.documentElement.scrollHeight - window.innerHeight
  progress.value = max > 0 ? Math.min(y / max, 1) : 0
}

const goTo = (id) => {
  const el = document.getElementById(id)
  if (el) el.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" })
}

const scrollTop = () =>
  window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" })

/* =========================
   PARALLAXE DU HERO
========================= */

const heroEl = ref(null)
const mouse = reactive({ x: 0, y: 0 })

const onHeroMove = (e) => {
  if (reduceMotion || !heroEl.value) return
  const r = heroEl.value.getBoundingClientRect()
  mouse.x = (e.clientX - r.left) / r.width - 0.5
  mouse.y = (e.clientY - r.top) / r.height - 0.5
}

const resetParallax = () => {
  mouse.x = 0
  mouse.y = 0
}

const emblemStyle = computed(() => ({
  transform: `translate3d(${mouse.x * -26}px, ${mouse.y * -26}px, 0)`
}))

const chipStyle = (depth) => ({
  transform: `translate3d(${mouse.x * depth * 2}px, ${mouse.y * depth * 2}px, 0)`
})

/* =========================
   CITATION (machine à écrire)
========================= */

const fullQuote =
  "« Il suffirait que deux d'entre eux se rencontrent, pour qu'ils créent une nouvelle Arménie. »"

const animatedQuote = ref("")
const quoteEl = ref(null)
let quoteTimer = null

const startQuoteAnimation = () => {
  if (reduceMotion) {
    animatedQuote.value = fullQuote
    return
  }
  let index = 0
  quoteTimer = setInterval(() => {
    animatedQuote.value = fullQuote.slice(0, ++index)
    if (index >= fullQuote.length) clearInterval(quoteTimer)
  }, 45)
}

/* =========================
   APPARITIONS AU SCROLL
========================= */

let revealObserver = null
let quoteObserver = null

const observeReveals = () => {
  if (!revealObserver) return
  document.querySelectorAll(".reveal:not(.show)").forEach((el) => revealObserver.observe(el))
}

onMounted(() => {
  loadEvents()

  const savedUser = localStorage.getItem("user")
  if (savedUser) {
    try {
      user.value = JSON.parse(savedUser)
    } catch {
      user.value = null
    }
  }

  revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show")
          revealObserver.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
  )
  observeReveals()

  if (quoteEl.value) {
    quoteObserver = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          startQuoteAnimation()
          quoteObserver.disconnect()
        }
      },
      { threshold: 0.45 }
    )
    quoteObserver.observe(quoteEl.value)
  }

  window.addEventListener("scroll", onScroll, { passive: true })
  document.addEventListener("click", onDocClick)
  onScroll()
  setTimeout(animateStats, 350)
})

onBeforeUnmount(() => {
  window.removeEventListener("scroll", onScroll)
  document.removeEventListener("click", onDocClick)
  revealObserver?.disconnect()
  quoteObserver?.disconnect()
  clearInterval(quoteTimer)
})
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,600;9..144,700&family=Instrument+Sans:wght@400;500;600;700&family=Noto+Serif+Armenian:wght@400;700&display=swap");

html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
}
html {
  scroll-padding-top: 80px;
}
</style>

<style scoped>
.page {
  --red: #d90012;
  --red-deep: #8f0010;
  --blue: #0033a0;
  --orange: #f2a800;
  --ink: #1c1511;
  --ink-soft: #3a2f28;
  --muted: #6e6259;
  --paper: #faf6ef;
  --paper-2: #f3ecdf;
  --line: rgba(28, 21, 17, 0.12);
  --serif: "Fraunces", "Noto Serif Armenian", Georgia, serif;
  --sans: "Instrument Sans", "Inter", system-ui, sans-serif;
  --arm: "Noto Serif Armenian", "Fraunces", serif;

  position: relative;
  width: 100%;
  overflow-x: clip;
  background: var(--paper);
  color: var(--ink);
  font-family: var(--sans);
  -webkit-font-smoothing: antialiased;
}
.page *,
.page *::before,
.page *::after {
  box-sizing: border-box;
}

/* ---------- progression ---------- */
.progress {
  position: fixed;
  inset: 0 0 auto 0;
  z-index: 300;
  height: 3px;
  transform-origin: left;
  background: linear-gradient(90deg, var(--red), var(--orange), var(--blue));
}

/* ---------- boutons ---------- */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 52px;
  padding: 0 26px;
  border: 1.5px solid transparent;
  border-radius: 999px;
  font: 600 15px/1 var(--sans);
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease, color 0.25s ease, border-color 0.25s ease;
}
.btn svg {
  transition: transform 0.25s ease;
}
.btn:hover svg {
  transform: translateX(4px);
}
.btn:active {
  transform: translateY(1px);
}
.btn-primary {
  background: var(--red);
  color: #fff;
  box-shadow: 0 10px 24px rgba(217, 0, 18, 0.28);
}
.btn-primary:hover {
  background: var(--red-deep);
  transform: translateY(-3px);
  box-shadow: 0 16px 32px rgba(217, 0, 18, 0.34);
}
.btn-ghost {
  background: transparent;
  color: var(--ink);
  border-color: var(--ink);
}
.btn-ghost:hover {
  background: var(--ink);
  color: var(--paper);
  transform: translateY(-3px);
}
.btn-outline {
  background: transparent;
  color: var(--red);
  border-color: var(--red);
}
.btn-outline:hover {
  background: var(--red);
  color: #fff;
  transform: translateY(-2px);
}
.btn-light {
  background: #fff;
  color: var(--red-deep);
}
.btn-light:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.25);
}
.btn-sm {
  min-height: 44px;
  padding: 0 20px;
  font-size: 14px;
}
.btn:focus-visible,
.pill-btn:focus-visible,
.topnav a:focus-visible,
.user-btn:focus-visible {
  outline: 3px solid var(--orange);
  outline-offset: 3px;
}

/* ---------- barre du haut ---------- */
.topbar {
  position: fixed;
  inset: 0 0 auto 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  height: 72px;
  padding: 0 clamp(16px, 4vw, 48px);
  transition: background 0.3s ease, box-shadow 0.3s ease, height 0.3s ease;
}
.topbar.scrolled {
  height: 62px;
  background: rgba(250, 246, 239, 0.9);
  box-shadow: 0 1px 0 var(--line);
  -webkit-backdrop-filter: blur(14px);
  backdrop-filter: blur(14px);
}
.wordmark {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--ink);
  text-decoration: none;
}
.wordmark-letter {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  transition: transform 0.4s ease;
}
.wordmark-letter img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.wordmark:hover .wordmark-letter {
  transform: rotate(-8deg) scale(1.06);
}
.wordmark-text {
  font: 600 20px/1 var(--serif);
  letter-spacing: -0.4px;
}
.wordmark-text b {
  color: var(--red);
  font-weight: 700;
}
.topnav {
  display: flex;
  gap: 6px;
}
.topnav a {
  position: relative;
  padding: 10px 14px;
  border-radius: 999px;
  color: var(--ink-soft);
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s ease, color 0.2s ease;
}
.topnav a:hover {
  background: rgba(28, 21, 17, 0.06);
  color: var(--ink);
}
.account {
  display: flex;
  align-items: center;
  gap: 8px;
}
.link-quiet {
  padding: 10px 12px;
  color: var(--ink-soft);
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
}
.link-quiet:hover {
  color: var(--red);
}
.pill-btn {
  display: inline-flex;
  align-items: center;
  min-height: 42px;
  padding: 0 18px;
  border-radius: 999px;
  background: var(--ink);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s ease, transform 0.2s ease;
}
.pill-btn:hover {
  background: var(--red);
  transform: translateY(-2px);
}
.user-menu {
  position: relative;
}
.user-btn {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  min-height: 44px;
  padding: 0 14px 0 6px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: #fff;
  color: var(--ink);
  font: 600 14px/1 var(--sans);
  cursor: pointer;
  transition: box-shadow 0.2s ease;
}
.user-btn:hover {
  box-shadow: 0 6px 18px rgba(28, 21, 17, 0.1);
}
.avatar {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border-radius: 50%;
  background: var(--red);
  color: #fff;
  font-weight: 700;
}
.menu {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  min-width: 230px;
  margin: 0;
  padding: 8px;
  list-style: none;
  border: 1px solid var(--line);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 20px 50px rgba(28, 21, 17, 0.16);
  transform-origin: top right;
}
.menu a,
.menu button {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  padding: 11px 14px;
  border: 0;
  border-radius: 10px;
  background: none;
  color: var(--ink);
  font: 600 14px/1.3 var(--sans);
  text-align: left;
  text-decoration: none;
  cursor: pointer;
}
.menu a:hover,
.menu button:hover {
  background: var(--paper-2);
}
.menu button {
  color: var(--red);
}
.menu-admin small {
  margin-top: 2px;
  color: var(--muted);
  font-size: 11px;
  font-weight: 500;
}
.pop-enter-active,
.pop-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.pop-enter-from,
.pop-leave-to {
  opacity: 0;
  transform: translateY(-6px) scale(0.97);
}

/* ---------- hero ---------- */
.hero {
  position: relative;
  display: flex;
  min-height: 100vh;
  min-height: 100svh;
  align-items: center;
  padding: 120px clamp(20px, 5vw, 72px) 90px;
  overflow: hidden;
}
.hero-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
/* Motif de croix arméniennes (croix à bras évasés) */
.lattice {
  position: absolute;
  inset: -60px;
  opacity: 0.75;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='104' height='163' viewBox='-60 -50 505 792' fill='none' opacity='.24'%3E%3Cmask id='m' maskUnits='userSpaceOnUse' x='-20' y='-20' width='425' height='710'%3E%3Crect x='-20' y='-20' width='425' height='710' fill='%23fff'/%3E%3Cpath d='M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z' fill='none' stroke='%23000' stroke-width='6' stroke-linejoin='round'/%3E%3C/mask%3E%3Cpath d='M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z' fill='none' stroke='%23d90012' stroke-width='19' stroke-linejoin='round' mask='url(%23m)'/%3E%3Cg transform='translate(98 40) rotate(-45)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(287 40) rotate(45)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(356 166) rotate(70)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(356 344) rotate(110)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(291 645) rotate(135)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(97 645) rotate(-135)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(29 344) rotate(-110)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(29 166) rotate(-70)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Ccircle cx='140' cy='44' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='140' cy='44' r='7' fill='%23d90012'/%3E%3Ccircle cx='245' cy='44' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='245' cy='44' r='7' fill='%23d90012'/%3E%3Ccircle cx='112' cy='88' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='112' cy='88' r='7' fill='%23d90012'/%3E%3Ccircle cx='272' cy='88' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='272' cy='88' r='7' fill='%23d90012'/%3E%3Ccircle cx='48' cy='208' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='48' cy='208' r='7' fill='%23d90012'/%3E%3Ccircle cx='48' cy='302' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='48' cy='302' r='7' fill='%23d90012'/%3E%3Ccircle cx='338' cy='208' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='338' cy='208' r='7' fill='%23d90012'/%3E%3Ccircle cx='338' cy='302' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='338' cy='302' r='7' fill='%23d90012'/%3E%3Ccircle cx='140' cy='602' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='140' cy='602' r='7' fill='%23d90012'/%3E%3Ccircle cx='245' cy='602' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='245' cy='602' r='7' fill='%23d90012'/%3E%3Ccircle cx='110' cy='592' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='110' cy='592' r='7' fill='%23d90012'/%3E%3Ccircle cx='275' cy='592' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='275' cy='592' r='7' fill='%23d90012'/%3E%3Ccircle cx='192' cy='245' r='76' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Cline x1='254.0' y1='245.0' x2='266.0' y2='245.0' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='250.3' y1='266.2' x2='261.5' y2='270.3' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='239.5' y1='284.9' x2='248.7' y2='292.6' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='223.0' y1='298.7' x2='229.0' y2='309.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='202.8' y1='306.1' x2='204.8' y2='317.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='181.2' y1='306.1' x2='179.2' y2='317.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='161.0' y1='298.7' x2='155.0' y2='309.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='144.5' y1='284.9' x2='135.3' y2='292.6' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='133.7' y1='266.2' x2='122.5' y2='270.3' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='130.0' y1='245.0' x2='118.0' y2='245.0' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='133.7' y1='223.8' x2='122.5' y2='219.7' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='144.5' y1='205.1' x2='135.3' y2='197.4' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='161.0' y1='191.3' x2='155.0' y2='180.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='181.2' y1='183.9' x2='179.2' y2='172.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='202.8' y1='183.9' x2='204.8' y2='172.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='223.0' y1='191.3' x2='229.0' y2='180.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='239.5' y1='205.1' x2='248.7' y2='197.4' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='250.3' y1='223.8' x2='261.5' y2='219.7' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Ccircle cx='192' cy='245' r='54' fill='none' stroke='%23d90012' stroke-width='9'/%3E%3Cpath d='M207.0 245.0 L209.9 247.4 L212.4 250.7 L214.3 254.6 L215.5 259.1 L215.8 264.1 L215.2 269.3 L213.5 274.7 L210.8 280.1 L206.9 285.2 L202.1 289.9' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M201.4 256.7 L201.3 260.5 L200.3 264.5 L198.4 268.4 L195.6 272.2 L191.9 275.5 L187.4 278.3 L182.1 280.4 L176.3 281.6 L169.9 281.8 L163.2 280.9' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M188.7 259.6 L185.6 261.9 L181.9 263.7 L177.7 264.6 L173.0 264.8 L168.1 264.0 L163.1 262.2 L158.2 259.3 L153.6 255.5 L149.5 250.6 L146.0 244.8' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M178.5 251.5 L174.8 250.6 L171.1 248.8 L167.7 246.1 L164.7 242.5 L162.3 238.2 L160.6 233.1 L159.7 227.5 L159.9 221.5 L161.1 215.3 L163.4 208.9' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M178.5 238.5 L176.9 235.0 L176.0 231.0 L176.0 226.7 L176.9 222.1 L178.8 217.5 L181.7 213.0 L185.5 208.9 L190.3 205.2 L196.0 202.3 L202.4 200.2' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M188.7 230.4 L190.4 227.0 L193.0 223.8 L196.4 221.1 L200.5 219.0 L205.3 217.5 L210.6 217.0 L216.2 217.4 L222.0 218.9 L227.9 221.5 L233.5 225.2' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M201.4 233.3 L205.1 232.5 L209.2 232.6 L213.4 233.5 L217.7 235.4 L221.7 238.3 L225.5 242.1 L228.7 246.7 L231.1 252.2 L232.8 258.4 L233.4 265.1' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Ccircle cx='192' cy='245' r='9' fill='%23d90012'/%3E%3Cpath d='M192.0 330.0 L195.0 333.0 L197.9 336.0 L200.6 339.0 L203.0 342.0 L205.1 345.0 L206.8 348.0 L208.1 351.0 L208.8 354.0 L209.0 357.0 L208.7 360.0 L207.8 363.0 L206.5 366.0 L204.7 369.0 L202.6 372.0 L200.1 375.0 L197.3 378.0 L194.4 381.0 L191.4 384.0 L188.4 387.0 L185.6 390.0 L182.9 393.0 L180.5 396.0 L178.5 399.0 L176.9 402.0 L175.8 405.0 L175.1 408.0 L175.0 411.0 L175.4 414.0 L176.4 417.0 L177.8 420.0 L179.7 423.0 L181.9 426.0 L184.5 429.0 L187.2 432.0 L190.2 435.0 L193.2 438.0 L196.1 441.0 L199.0 444.0 L201.6 447.0 L203.9 450.0 L205.8 453.0 L207.4 456.0 L208.4 459.0 L208.9 462.0 L208.9 465.0 L208.4 468.0 L207.4 471.0 L205.9 474.0 L203.9 477.0 L201.6 480.0 L199.0 483.0 L196.2 486.0 L193.2 489.0 L190.2 492.0 L187.3 495.0 L184.5 498.0 L181.9 501.0 L179.7 504.0 L177.8 507.0 L176.4 510.0 L175.5 513.0 L175.0 516.0 L175.1 519.0 L175.8 522.0 L176.9 525.0 L178.5 528.0 L180.5 531.0 L182.9 534.0 L185.5 537.0 L188.4 540.0 L191.4 543.0' fill='none' stroke='%23d90012' stroke-width='10' stroke-linecap='round'/%3E%3Cpath d='M192.0 330.0 L189.0 333.0 L186.1 336.0 L183.4 339.0 L181.0 342.0 L178.9 345.0 L177.2 348.0 L175.9 351.0 L175.2 354.0 L175.0 357.0 L175.3 360.0 L176.2 363.0 L177.5 366.0 L179.3 369.0 L181.4 372.0 L183.9 375.0 L186.7 378.0 L189.6 381.0 L192.6 384.0 L195.6 387.0 L198.4 390.0 L201.1 393.0 L203.5 396.0 L205.5 399.0 L207.1 402.0 L208.2 405.0 L208.9 408.0 L209.0 411.0 L208.6 414.0 L207.6 417.0 L206.2 420.0 L204.3 423.0 L202.1 426.0 L199.5 429.0 L196.8 432.0 L193.8 435.0 L190.8 438.0 L187.9 441.0 L185.0 444.0 L182.4 447.0 L180.1 450.0 L178.2 453.0 L176.6 456.0 L175.6 459.0 L175.1 462.0 L175.1 465.0 L175.6 468.0 L176.6 471.0 L178.1 474.0 L180.1 477.0 L182.4 480.0 L185.0 483.0 L187.8 486.0 L190.8 489.0 L193.8 492.0 L196.7 495.0 L199.5 498.0 L202.1 501.0 L204.3 504.0 L206.2 507.0 L207.6 510.0 L208.5 513.0 L209.0 516.0 L208.9 519.0 L208.2 522.0 L207.1 525.0 L205.5 528.0 L203.5 531.0 L201.1 534.0 L198.5 537.0 L195.6 540.0 L192.6 543.0' fill='none' stroke='%23d90012' stroke-width='10' stroke-linecap='round'/%3E%3Ccircle cx='192' cy='330.0' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='356.7' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='383.4' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='410.1' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='436.8' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='463.5' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='490.2' r='5' fill='%23d90012'/%3E%3Cg transform='translate(192 170) rotate(0)'%3E%3Cpath d='M0 18 L0 -6' stroke='%23d90012' stroke-width='6' stroke-linecap='round'/%3E%3Cpath d='M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(192 555) rotate(180)'%3E%3Cpath d='M0 18 L0 -6' stroke='%23d90012' stroke-width='6' stroke-linecap='round'/%3E%3Cpath d='M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z' fill='%23d90012'/%3E%3C/g%3E%3Cpath d='M192 560 L165 590 L192 600 L219 590Z' fill='none' stroke='%23d90012' stroke-width='6' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-size: 104px 163px;
  -webkit-mask-image: radial-gradient(ellipse 80% 70% at 70% 45%, #000 0%, transparent 75%);
  mask-image: radial-gradient(ellipse 80% 70% at 70% 45%, #000 0%, transparent 75%);
  animation: drift 40s linear infinite;
}
@keyframes drift {
  to { background-position: 104px 163px; }
}
.bg-cross {
  position: absolute;
  height: auto;
  aspect-ratio: 453 / 752;
  user-select: none;
}
.bg-cross--a {
  left: -1vw;
  bottom: -5vh;
  width: clamp(170px, 24vw, 360px);
  color: rgba(28, 21, 17, 0.07);
  animation: floatY 14s ease-in-out infinite;
}
.bg-cross--b {
  top: 8vh;
  right: 30vw;
  width: clamp(80px, 10vw, 150px);
  color: rgba(217, 0, 18, 0.13);
  animation: floatY 11s ease-in-out -4s infinite reverse;
}
.bg-stripe {
  position: absolute;
  inset: auto 0 0 0;
  height: 6px;
  background: linear-gradient(90deg, var(--red) 0 33.3%, var(--blue) 33.3% 66.6%, var(--orange) 66.6%);
}
@keyframes floatY {
  0%, 100% { transform: translateY(0) rotate(-2deg); }
  50% { transform: translateY(-26px) rotate(2deg); }
}
.hero-grid {
  position: relative;
  z-index: 2;
  display: grid;
  width: 100%;
  max-width: 1280px;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);
  align-items: center;
  gap: clamp(24px, 5vw, 80px);
  margin: 0 auto;
}
.eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 26px;
  padding: 8px 16px 8px 12px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.6);
  color: var(--ink-soft);
  font: 600 13px/1 var(--sans);
  letter-spacing: 0.2px;
}
.eyebrow-cross {
  width: 12px;
  height: 20px;
  flex-shrink: 0;
  color: var(--red);
}
.hero h1 {
  margin: 0;
  font: 600 clamp(38px, 5.6vw, 76px) / 1.05 var(--serif);
  letter-spacing: -0.03em;
  color: var(--ink);
  animation: rise 0.9s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.h1-accent {
  position: relative;
  display: inline-block;
  margin-top: 6px;
  color: var(--red);
  font-style: italic;
  font-weight: 500;
}
.underline {
  position: absolute;
  left: 0;
  bottom: -8px;
  width: 100%;
  height: 8px;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 8' preserveAspectRatio='none'%3E%3Cpath d='M0 5 Q25 0 50 4 T100 4 T150 4 T200 3' fill='none' stroke='%23f2a800' stroke-width='3' stroke-linecap='round'/%3E%3C/svg%3E") center / 100% 100% no-repeat;
  transform-origin: left;
  animation: draw 1.1s 0.7s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
@keyframes draw {
  from { transform: scaleX(0); }
}
@keyframes rise {
  from { opacity: 0; transform: translateY(26px); }
}
.lead {
  max-width: 540px;
  margin: 28px 0 0;
  color: var(--ink-soft);
  font-size: clamp(16px, 1.5vw, 19px);
  line-height: 1.7;
  animation: rise 0.9s 0.12s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 36px;
  animation: rise 0.9s 0.24s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.stats {
  display: flex;
  flex-wrap: wrap;
  gap: 14px 40px;
  margin: 48px 0 0;
  padding-top: 26px;
  border-top: 1px solid var(--line);
  animation: rise 0.9s 0.36s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.stat dt {
  font: 600 clamp(30px, 3.4vw, 42px) / 1 var(--serif);
  letter-spacing: -0.03em;
  font-variant-numeric: tabular-nums;
}
.stat-plus {
  color: var(--red);
}
.stat dd {
  margin: 6px 0 0;
  color: var(--muted);
  font-size: 14px;
}

/* ---------- emblème ---------- */
.hero-art {
  position: relative;
  display: grid;
  aspect-ratio: 1;
  width: min(100%, 540px);
  margin-inline: auto;
  place-items: center;
  animation: rise 1.1s 0.2s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.emblem {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.35s ease-out;
}
.ring {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}
.ring--text text {
  fill: var(--ink);
  font: 700 17.5px var(--arm);
  letter-spacing: 5px;
}
.ring--text {
  animation: spin 60s linear infinite;
}
.ring--geo {
  inset: 6%;
  width: 88%;
  height: 88%;
  animation: spin 90s linear infinite reverse;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
.core {
  position: absolute;
  inset: 31%;
  display: grid;
  place-content: center;
  justify-items: center;
  border-radius: 50%;
  background: #fff;
  color: var(--ink);
  box-shadow: 0 30px 60px rgba(28, 21, 17, 0.18);
}
.core::after {
  position: absolute;
  inset: -10px;
  border: 1.5px dashed rgba(242, 168, 0, 0.7);
  border-radius: 50%;
  content: "";
  animation: spin 24s linear infinite;
}
.core-logo {
  width: clamp(80px, 13.5vw, 160px);
  height: auto;
  object-fit: contain;
}
caption {
  margin-top: -4px;
  font: 500 13px var(--serif);
  letter-spacing: 4px;
  text-transform: uppercase;
  opacity: 0.6;
}
.chip {
  position: absolute;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 11px 18px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(28, 21, 17, 0.12);
  font: 600 14px/1 var(--sans);
  transition: transform 0.4s ease-out;
}
.chip .dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
}
.dot.red { background: var(--red); }
.dot.blue { background: var(--blue); }
.dot.orange { background: var(--orange); }
.chip--a { top: 8%; left: -2%; animation: bob 6s ease-in-out infinite; }
.chip--b { top: 46%; right: -6%; animation: bob 7s ease-in-out -2s infinite; }
.chip--c { bottom: 6%; left: 8%; animation: bob 8s ease-in-out -4s infinite; }
@keyframes bob {
  0%, 100% { margin-top: 0; }
  50% { margin-top: -14px; }
}
.scroll-cue {
  position: absolute;
  bottom: 28px;
  left: 50%;
  z-index: 3;
  width: 26px;
  height: 42px;
  transform: translateX(-50%);
  border: 2px solid var(--ink);
  border-radius: 14px;
  opacity: 0.55;
}
.scroll-cue span {
  position: absolute;
  top: 7px;
  left: 50%;
  width: 4px;
  height: 8px;
  margin-left: -2px;
  border-radius: 2px;
  background: var(--ink);
  animation: wheel 1.8s ease-in-out infinite;
}
@keyframes wheel {
  0% { opacity: 0; transform: translateY(0); }
  30% { opacity: 1; }
  100% { opacity: 0; transform: translateY(14px); }
}

/* ---------- bandeau ---------- */
.marquee {
  position: relative;
  z-index: 4;
  overflow: hidden;
  margin: -14px -10px 0;
  padding: 20px 0;
  background: var(--ink);
  color: var(--paper);
  transform: rotate(-1deg);
}
.marquee-track {
  display: flex;
  width: max-content;
  animation: marquee 36s linear infinite;
}
.marquee:hover .marquee-track {
  animation-play-state: paused;
}
.marquee-item {
  display: inline-flex;
  align-items: center;
  gap: 28px;
  padding-right: 28px;
  font: 500 clamp(22px, 3vw, 34px) / 1 var(--serif);
  font-style: italic;
  white-space: nowrap;
}
.marquee-item i {
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  background: var(--orange);
}
.marquee-item:nth-child(3n) i { background: var(--red); }
.marquee-item:nth-child(3n + 1) i { background: #4d78d6; }
@keyframes marquee {
  to { transform: translateX(-50%); }
}

/* ---------- citation ---------- */
.quote-section {
  position: relative;
  padding: clamp(90px, 12vw, 150px) clamp(20px, 6vw, 80px) clamp(70px, 10vw, 120px);
  text-align: center;
  background: var(--paper-2);
}
.quote-mark {
  display: block;
  width: 54px;
  height: 54px;
  margin: 0 auto 22px;
  fill: var(--red);
  opacity: 0.9;
}
.quote {
  position: relative;
  display: block;
  max-width: 980px;
  margin: 0 auto;
  font: italic 500 clamp(26px, 4vw, 46px) / 1.35 var(--serif);
  letter-spacing: -0.015em;
  color: var(--ink);
}
.quote-ghost {
  visibility: hidden;
}
.quote-typed {
  position: absolute;
  inset: 0;
  text-align: center;
}
.caret {
  display: inline-block;
  width: 3px;
  height: 0.9em;
  margin-left: 4px;
  transform: translateY(0.1em);
  background: var(--red);
  animation: blink 0.9s steps(1) infinite;
}
@keyframes blink {
  50% { opacity: 0; }
}
.quote-author {
  margin: 28px 0 0;
  color: var(--muted);
  font-size: 14px;
  letter-spacing: 0.4px;
}

/* ---------- titres de section ---------- */
.kicker {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--red);
  font: 700 13px/1 var(--sans);
  letter-spacing: 0.16em;
  text-transform: uppercase;
}
.kicker-cross {
  width: 19px;
  height: 32px;
  flex-shrink: 0;
}
.kicker::before {
  width: 28px;
  height: 2px;
  background: var(--red);
  content: "";
}
h2 {
  margin: 14px 0 0;
  font: 600 clamp(32px, 4.4vw, 56px) / 1.08 var(--serif);
  letter-spacing: -0.028em;
}
h2 em {
  color: var(--red);
  font-weight: 500;
}

/* ---------- mission ---------- */
.mission {
  display: grid;
  max-width: 1280px;
  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
  gap: clamp(32px, 6vw, 90px);
  margin: 0 auto;
  padding: clamp(80px, 10vw, 140px) clamp(20px, 5vw, 72px);
}
.mission-intro {
  position: sticky;
  top: 110px;
  align-self: start;
}
.mission-intro p {
  max-width: 420px;
  margin: 22px 0 0;
  color: var(--ink-soft);
  font-size: 18px;
  line-height: 1.75;
}
.values {
  display: grid;
  gap: 20px;
}
.value {
  position: relative;
  display: grid;
  grid-template-columns: 56px 1fr;
  column-gap: 22px;
  padding: 34px 34px 34px 30px;
  overflow: hidden;
  border: 1px solid var(--line);
  border-radius: 24px;
  background: #fff;
  transition: transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.4s ease, border-color 0.3s ease;
}
.value::before {
  position: absolute;
  inset: 0 auto 0 0;
  width: 5px;
  background: var(--red);
  content: "";
  transition: width 0.4s ease;
}
.value:nth-child(2)::before { background: var(--blue); }
.value:nth-child(3)::before { background: var(--orange); }
.value:hover {
  transform: translateX(8px);
  border-color: transparent;
  box-shadow: 0 24px 50px rgba(28, 21, 17, 0.1);
}
.value:hover::before { width: 9px; }
.value-num {
  position: absolute;
  top: 18px;
  right: 26px;
  color: rgba(28, 21, 17, 0.1);
  font: 600 56px/1 var(--serif);
  transition: color 0.3s ease;
}
.value:hover .value-num {
  color: rgba(217, 0, 18, 0.25);
}
.value-icon {
  display: grid;
  grid-row: span 2;
  width: 56px;
  height: 56px;
  place-items: center;
  border-radius: 16px;
  background: var(--paper-2);
  color: var(--red);
  transition: background 0.3s ease, color 0.3s ease, transform 0.4s ease;
}
.value:nth-child(2) .value-icon { color: var(--blue); }
.value:nth-child(3) .value-icon { color: #b97f00; }
.value:hover .value-icon {
  background: var(--ink);
  color: var(--orange);
  transform: rotate(-6deg);
}
.value-icon :deep(svg) {
  width: 28px;
  height: 28px;
}
.value h3 {
  margin: 2px 0 8px;
  font: 600 26px/1.2 var(--serif);
  letter-spacing: -0.02em;
}
.value p {
  max-width: 460px;
  margin: 0;
  color: var(--muted);
  font-size: 16px;
  line-height: 1.7;
}

/* ---------- événements ---------- */
.events {
  padding: clamp(80px, 10vw, 130px) clamp(20px, 5vw, 72px);
  background: var(--ink);
  color: var(--paper);
}
.events .kicker { color: var(--orange); }
.events .kicker::before { background: var(--orange); }
.events-head {
  display: flex;
  max-width: 1280px;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 28px;
  margin: 0 auto;
}
.events-head p {
  max-width: 460px;
  margin: 16px 0 0;
  color: rgba(250, 246, 239, 0.65);
  font-size: 17px;
  line-height: 1.7;
}
.events-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.events .btn-outline {
  color: var(--paper);
  border-color: rgba(250, 246, 239, 0.4);
}
.events .btn-outline:hover {
  background: var(--paper);
  color: var(--ink);
  border-color: var(--paper);
}
.events-grid {
  display: grid;
  max-width: 1280px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  margin: 54px auto 0;
}
.event-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 24px;
  background: var(--paper);
  color: var(--ink);
  transition: transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.4s ease;
}
.event-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.4);
}
.event-image {
  position: relative;
  height: 230px;
  overflow: hidden;
}
.event-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.7s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.event-card:hover .event-image img { transform: scale(1.07); }
.event-placeholder {
  display: grid;
  height: 100%;
  place-items: center;
  background: repeating-linear-gradient(45deg, rgba(217, 0, 18, 0.06) 0 2px, transparent 2px 18px), var(--paper-2);
}
.placeholder-cross {
  height: 74%;
  aspect-ratio: 453 / 752;
  color: var(--red);
  opacity: 0.45;
}
.event-date {
  position: absolute;
  top: 16px;
  left: 16px;
  display: flex;
  width: 60px;
  height: 66px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
}
.event-date strong {
  color: var(--red);
  font: 700 24px/1 var(--serif);
}
.event-date span {
  margin-top: 5px;
  color: var(--ink-soft);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
}
.event-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 24px 26px 22px;
}
.event-location,
.event-time {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--red);
  font-size: 13px;
  font-weight: 600;
}
.event-content h3 {
  margin: 10px 0 0;
  font: 600 23px/1.25 var(--serif);
  letter-spacing: -0.015em;
}
.event-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-top: auto;
  padding-top: 24px;
}
.event-time { color: var(--muted); }
.event-details-btn {
  padding: 0;
  border: 0;
  background: none;
  color: var(--ink);
  font: 700 14px var(--sans);
  cursor: pointer;
  transition: color 0.2s ease;
}
.event-details-btn span {
  display: inline-block;
  transition: transform 0.25s ease;
}
.event-details-btn:hover { color: var(--red); }
.event-details-btn:hover span { transform: translateX(5px); }
.event-card.skeleton {
  height: 420px;
  background: linear-gradient(100deg, rgba(255, 255, 255, 0.06) 30%, rgba(255, 255, 255, 0.14) 50%, rgba(255, 255, 255, 0.06) 70%);
  background-size: 200% 100%;
  animation: shimmer 1.4s linear infinite;
}
@keyframes shimmer {
  to { background-position: -200% 0; }
}
.events-empty {
  display: flex;
  max-width: 560px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin: 54px auto 0;
  padding: 44px 30px;
  border: 1.5px dashed rgba(250, 246, 239, 0.28);
  border-radius: 24px;
  text-align: center;
}
.empty-cross {
  width: 46px;
  height: 76px;
  color: var(--orange);
}
.events-empty h3 {
  margin: 4px 0 0;
  font: 600 24px var(--serif);
}
.events-empty p {
  margin: 0 0 14px;
  color: rgba(250, 246, 239, 0.65);
}

/* ---------- don : design amélioré ---------- */
.donation {
  position: relative;
  padding: clamp(76px, 9vw, 124px) clamp(20px, 5vw, 72px);
  background:
    radial-gradient(ellipse at 8% 15%, rgba(242, 168, 0, 0.09), transparent 34%),
    var(--paper);
}
.donation-box {
  position: relative;
  isolation: isolate;
  display: grid;
  max-width: 1180px;
  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);
  align-items: center;
  gap: clamp(32px, 5vw, 76px);
  margin: 0 auto;
  padding: clamp(32px, 5vw, 68px);
  overflow: hidden;
  border: 1px solid rgba(28, 21, 17, 0.08);
  border-radius: 32px;
  background: linear-gradient(135deg, #fff 0%, #fffaf3 62%, #f8eee2 100%);
  color: var(--ink);
  box-shadow: 0 24px 70px rgba(66, 43, 24, 0.09);
}
.donation-box::before {
  position: absolute;
  z-index: -1;
  inset: 0 0 auto;
  height: 5px;
  background: linear-gradient(90deg, var(--red) 0 42%, var(--blue) 42% 72%, var(--orange) 72%);
  content: "";
}
.donation-box::after {
  position: absolute;
  z-index: -1;
  top: -150px;
  right: -120px;
  width: 360px;
  height: 360px;
  border: 1px solid rgba(217, 0, 18, 0.08);
  border-radius: 50%;
  box-shadow: 0 0 0 28px rgba(217, 0, 18, 0.025), 0 0 0 58px rgba(0, 51, 160, 0.025);
  content: "";
  pointer-events: none;
}
.donation-art {
  position: relative;
  display: grid;
  aspect-ratio: 1;
  width: 100%;
  max-width: 310px;
  margin-inline: auto;
  place-items: center;
}
.donation-art .ring {
  position: absolute;
  inset: auto;
  border: 1px solid rgba(217, 0, 18, 0.16);
  border-radius: 50%;
  animation: ripple 5.5s ease-out infinite;
}
.donation-art .r1 {
  width: 100%;
  height: 100%;
}
.donation-art .r2 {
  width: 100%;
  height: 100%;
  animation-delay: -1.8s;
}
.donation-art .r3 {
  width: 100%;
  height: 100%;
  animation-delay: -3.6s;
}
@keyframes ripple {
  0% {
    transform: scale(0.48);
    opacity: 0.9;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.donation-letter {
  position: relative;
  display: grid;
  width: 47%;
  aspect-ratio: 1;
  place-items: center;
  border: 1px solid rgba(217, 0, 18, 0.1);
  border-radius: 50%;
  background: linear-gradient(145deg, #fff 0%, #fff7f0 100%);
  color: var(--red);
  box-shadow: 0 18px 44px rgba(92, 32, 24, 0.13);
}
.donation-cross {
  width: 50%;
  aspect-ratio: 473 / 752;
  height: auto;
}
.donation-letter::after {
  position: absolute;
  inset: 9px;
  border: 1px dashed rgba(242, 168, 0, 0.65);
  border-radius: 50%;
  content: "";
}
.donation-content {
  position: relative;
  z-index: 1;
}
.donation-small {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border: 1px solid rgba(217, 0, 18, 0.13);
  border-radius: 999px;
  background: rgba(217, 0, 18, 0.045);
  color: var(--red-deep);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}
.donation-small::before {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--red);
  content: "";
}
.donation-content h2 {
  max-width: 620px;
  margin-top: 22px;
  color: var(--ink);
  font-size: clamp(32px, 4vw, 52px);
  line-height: 1.08;
}
.donation-content h2 em {
  color: var(--red);
}
.donation-content p {
  max-width: 550px;
  margin: 20px 0 0;
  color: var(--muted);
  font-size: clamp(16px, 1.4vw, 18px);
  line-height: 1.8;
}
.donation-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px 22px;
  margin-top: 30px;
}
.donation-actions .btn-primary {
  min-height: 50px;
  padding-inline: 24px;
  box-shadow: 0 9px 22px rgba(217, 0, 18, 0.18);
}
.donation-actions .btn-primary:hover {
  box-shadow: 0 14px 28px rgba(217, 0, 18, 0.24);
}
.donation-actions span {
  color: var(--muted);
  font-size: 13px;
  line-height: 1.5;
}
.donation-actions span::before {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin: 0 8px 2px 0;
  border-radius: 50%;
  background: var(--orange);
  content: "";
}

/* ---------- partenaires ---------- */
.partners {
  max-width: 1280px;
  margin: 0 auto;
  padding: clamp(40px, 6vw, 80px) clamp(20px, 5vw, 72px) clamp(90px, 10vw, 140px);
}
.partners-head p {
  max-width: 520px;
  margin: 16px 0 0;
  color: var(--muted);
  font-size: 17px;
  line-height: 1.7;
}
.partner-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  margin-top: 48px;
}
.partner-card {
  display: grid;
  height: 180px;
  place-items: center;
  padding: 30px;
  border: 1px solid var(--line);
  border-radius: 24px;
  background: #fff;
  transition: transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.4s ease, border-color 0.3s ease;
}
.partner-card img {
  max-width: 100%;
  max-height: 100px;
  object-fit: contain;
  filter: grayscale(1);
  opacity: 0.7;
  transition: filter 0.3s ease, opacity 0.3s ease, transform 0.4s ease;
}
.partner-card:hover {
  transform: translateY(-8px);
  border-color: transparent;
  box-shadow: 0 24px 50px rgba(28, 21, 17, 0.12);
}
.partner-card:hover img {
  filter: none;
  opacity: 1;
  transform: scale(1.05);
}

/* ---------- footer ---------- */
.footer {
  padding: clamp(60px, 8vw, 100px) clamp(20px, 5vw, 72px) 28px;
  background: var(--ink);
  color: var(--paper);
  border-top: 6px solid var(--red);
}
.footer-top {
  display: grid;
  max-width: 1280px;
  grid-template-columns: minmax(0, 1.5fr) repeat(2, minmax(0, 1fr));
  gap: clamp(30px, 5vw, 80px);
  margin: 0 auto;
}
.footer-wordmark {
  font: 600 clamp(32px, 4vw, 48px)/1 var(--serif);
  letter-spacing: -0.03em;
}
.footer-wordmark b { color: var(--orange); }
.footer-brand p {
  max-width: 360px;
  margin: 18px 0 26px;
  color: rgba(250, 246, 239, 0.62);
  line-height: 1.7;
}
.social-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.social-link {
  display: grid;
  width: 46px;
  height: 46px;
  place-items: center;
  border: 1px solid rgba(250, 246, 239, 0.18);
  border-radius: 14px;
  color: var(--paper);
  transition: transform 0.25s ease, background 0.25s ease, border-color 0.25s ease, color 0.25s ease;
}
.social-link svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.social-link :deep(.fill) {
  fill: currentColor;
  stroke: none;
}
.social-link:hover {
  transform: translateY(-4px);
  border-color: var(--orange);
  background: var(--orange);
  color: var(--ink);
}
.footer-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.footer-column h3 {
  margin: 0 0 12px;
  color: var(--orange);
  font: 700 12px/1 var(--sans);
  letter-spacing: 0.16em;
  text-transform: uppercase;
}
.footer-column a {
  position: relative;
  padding: 7px 0;
  color: rgba(250, 246, 239, 0.8);
  font-size: 16px;
  text-decoration: none;
  transition: color 0.2s ease, transform 0.25s ease;
}
.footer-column a:hover {
  color: #fff;
  transform: translateX(6px);
}
.footer-bottom {
  display: flex;
  max-width: 1280px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: clamp(40px, 6vw, 70px) auto 0;
  padding-top: 24px;
  border-top: 1px solid rgba(250, 246, 239, 0.14);
  color: rgba(250, 246, 239, 0.5);
  font-size: 14px;
}
.footer-bottom p { margin: 0; }
.to-top {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border: 1px solid rgba(250, 246, 239, 0.25);
  border-radius: 50%;
  background: none;
  color: var(--paper);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, transform 0.25s ease;
}
.to-top:hover {
  background: var(--paper);
  color: var(--ink);
  transform: translateY(-4px);
}

/* ---------- apparition au scroll ---------- */
.reveal {
  opacity: 0;
  transform: translateY(44px);
  transition: opacity 0.8s ease var(--d, 0s), transform 0.9s cubic-bezier(0.2, 0.8, 0.2, 1) var(--d, 0s), box-shadow 0.4s ease, border-color 0.3s ease;
}
.reveal.show {
  opacity: 1;
  transform: none;
}
.value.reveal.show:hover { transform: translateX(8px); }
.event-card.reveal.show:hover { transform: translateY(-10px); }
.partner-card.reveal.show:hover { transform: translateY(-8px); }

/* ---------- responsive ---------- */
@media (max-width: 1024px) {
  .topnav { display: none; }
  .hero-grid {
    grid-template-columns: 1fr;
    text-align: left;
  }
  .hero-art {
    width: min(86%, 420px);
    margin-top: 10px;
  }
  .mission { grid-template-columns: 1fr; }
  .mission-intro { position: static; }
  .events-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .donation-box {
    grid-template-columns: 1fr;
    gap: 24px;
    text-align: center;
  }
  .donation-art { max-width: 220px; }
  .donation-content p { margin-inline: auto; }
  .donation-actions { justify-content: center; }
  .donation-box::after {
    top: -180px;
    right: -160px;
  }
  .footer-top { grid-template-columns: 1fr 1fr; }
  .footer-brand { grid-column: 1 / -1; }
}

@media (max-width: 720px) {
  .bg-cross--a { width: 150px; left: -4vw; }
  .bg-cross--b { right: 6vw; top: 14vh; width: 72px; }
  .topbar { height: 62px; }
  .link-quiet { display: none; }
  .user-label { display: none; }
  .user-btn { padding: 0 10px 0 6px; }

  .hero {
    padding-top: 100px;
    padding-bottom: 80px;
  }
  .hero-actions .btn { flex: 1 1 100%; }
  .stats { gap: 14px 28px; }
  .chip { font-size: 12px; padding: 9px 14px; }
  .chip--a { left: 0; }
  .chip--b { right: -2%; }
  .scroll-cue { display: none; }

  .value {
    grid-template-columns: 1fr;
    padding: 28px 24px 28px 28px;
  }
  .value-icon {
    grid-row: auto;
    margin-bottom: 18px;
  }
  .value:hover,
  .value.reveal.show:hover { transform: none; }

  .events-grid,
  .partner-list { grid-template-columns: 1fr; }
  .events-actions { width: 100%; }
  .events-actions .btn { flex: 1 1 100%; }
  .event-card:hover,
  .event-card.reveal.show:hover { transform: none; }

  .donation {
    padding-inline: 16px;
  }
  .donation-box {
    gap: 20px;
    padding: 30px 22px;
    border-radius: 24px;
  }
  .donation-art { max-width: 180px; }
  .donation-content h2 {
    margin-top: 18px;
    font-size: clamp(30px, 8vw, 40px);
  }
  .donation-content p {
    margin-top: 14px;
    font-size: 16px;
    line-height: 1.7;
  }
  .donation-actions {
    gap: 14px;
    margin-top: 24px;
  }
  .donation-actions .btn { width: 100%; }
  .donation-actions span { font-size: 12px; }
  .donation-box::after {
    top: -130px;
    right: -190px;
    width: 280px;
    height: 280px;
  }

  .footer-top { grid-template-columns: 1fr; }
  .footer-bottom { font-size: 13px; }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
  .reveal {
    opacity: 1;
    transform: none;
  }
  .marquee-track { animation: none; }
}

@media (max-width: 720px) {
  .footer {
    padding: 48px 20px 24px;
    text-align: center;
  }

  .footer-top {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    width: 100%;
    text-align: center;
  }

  .footer-brand {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    grid-column: auto;
    text-align: center;
  }

  .footer-brand p {
    margin: 16px auto 24px;
    text-align: center;
  }

  .social-grid {
    justify-content: center;
    width: 100%;
  }

  .footer-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 6px;
    text-align: center;
  }

  .footer-column h3 {
    margin-bottom: 10px;
    text-align: center;
  }

  .footer-column a {
    padding: 6px 0;
    text-align: center;
  }

  .footer-column a:hover {
    transform: none;
  }

  .footer-bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    width: 100%;
    text-align: center;
  }

  .footer-bottom p {
    text-align: center;
  }

  .to-top {
    margin-inline: auto;
  }
}
</style>